/* eslint-disable i18next/no-literal-string */
import React, { useEffect, useState } from 'react';
import {
  IconButton,
  Paper,
  Grid,
  Theme,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  ClickAwayListener,
  Box,
  Popper,
  Tooltip,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { keyframes } from 'tss-react';
import { useInjectReducer } from 'redux-injectors';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectNavigationStick } from './NavigationStick.selectors';
import {
  navigationStickSliceKey,
  navigationStickActions,
  navigationStickReducers,
  INavigation,
  NavigationOption,
  NavigationSubTypes,
  NavigationStick,
  INavigationPopperState,
} from './NavigationStick.redux';
import { getStickIcons } from './iconHelper';
import { trackEvent } from 'app-insights/appInsightsTracking';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { colors } from 'styles/styleVariables';
import { PrivateComponent } from '../Common/PrivateComponent/PrivateComponent';
import { selectUser } from 'oidc/user.selectors';
import { DEFAULT_HOME_PAGE_LOCAL_STORAGE_KEY } from '../AppHome/helper';
import { isAccountManagement, isCredentialing, isRecruitment, isGrantedAllDashboards } from 'oidc/userRoles';
import { Authorized } from 'oidc/userHelper';
import { breadcrumbActions } from '../Common/BreadcrumbNavigation/BreadcrumbNavigation.redux';
import { globalSearchActions, initialSearchAttributes } from 'store/redux-store/global-search/slice';
import { useRecentHistoryNavigation } from './RecentHistoryItems';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { useDecision } from '@optimizely/react-sdk';
import { OverflowTooltip } from '@AMIEWEB/Common';
import { HomePage } from '@AMIEWEB/AppHome/AppHome';
import { ff_pricing_ui_pricingworkdesk } from 'app/constants/FeatureFlags/Sidenav/Keys';
import { ff_order_margintool } from 'app/constants/FeatureFlags/Sidenav/Keys';
import { ff_ui_showhomecoverage } from 'app/constants/FeatureFlags/EmployeeCoverage/keys';
import { ff_task_ui_taskspage } from 'app/constants/FeatureFlags/Global/keys';
import { ff_candidate_leads_management } from 'app/constants/FeatureFlags/Candidate/Keys';
import { userRoles } from 'oidc/userRoles';
import { openInNewTab } from 'app/helpers/openInNewTab';
import { gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { useFetchSubMenuList } from './helper';
import CandidateIcon from 'app/assets/images/NavigationStick/Candidates-Icon.svg';
import FacilityIcon from 'app/assets/images/NavigationStick/Facilities-Icon.svg';
import OrdersIcon from 'app/assets/images/NavigationStick/Orders-Icon.svg';
import PlacementIcon from 'app/assets/images/NavigationStick/Placements-Icon.svg';
import { theme } from 'styles/global-styles';
const useStyles = makeStyles()(() => ({
  root: {
    height: '100vh',
    background: '#52429A',
    borderRight: '1px solid #F5F5F5',
  },
  drawerCollapse: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawer: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  collapseIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 49,
    color: '#F5F5F5',
  },
  headerIcon: {
    color: '#F5F5F5',
  },
  listItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  listItemGutters: {
    paddingLeft: 8,
    paddingRight: 4,
  },
  borderSelection: {
    borderLeft: '5px solid',
    borderImage: 'linear-gradient(180deg, #009AD9 0%, #009AD9 0%, #52429A 100%) 1 100%',
  },
  invertItemColor: {
    filter: `invert(50%) brightness(294%)`,
  },
  listIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '30px',
  },
  option: {
    '&:hover': {
      backgroundColor: '#372C67',
    },
    display: 'flex',
    color: 'white',
  },
  optionSelected: {
    backgroundColor: '#F5F5F5',
  },
  menuInner: {
    width: '130px',
    zIndex: 100,
    paddingLeft: '10px',
    top: '0px',
    marginLeft: '-160px',
    opacity: '0',
    maxHeight: '26px',
    overflow: 'hidden',
  },
  menuInnerCollapsed: {
    '&.navigation-collapsed': {
      marginLeft: '0px',
      opacity: '1',
      animation: `${keyframes`
      0% {
        opacity: 1;
      }
      15% {
        opacity: 0;
      }
      100% {
        opacity: 0;
        margin-left: -160px;
      }
      `} 150ms linear 1 normal forwards`,
    },
  },
  menuInnerExpanded: {
    '&.navigation-expanded': {
      marginLeft: '-160px',
      opacity: '0',
      maxHeight: 'none',
      overflow: 'visible',
      animation: `${keyframes`
      75% {
        opacity: 0;
      }
      100% {
        opacity: 1;
        margin-left: 0px;
      }
      `} 150ms linear 1 normal forwards`,
    },
  },
  menuList: {
    position: 'absolute',
    zIndex: theme.zIndex.drawer + 2,
    backgroundColor: '#52429A',
    boxShadow: '4px -1px 4px -1px rgba(0,0,0,0.24)',
  },
  menuListExpanded: {
    height: 'unset',
    paddingBottom: '0px',
    animation: `${keyframes`
    1% {
      height: 100vh;
      padding-bottom: 50px;
    }
    100% {
      height: 100vh;
      padding-bottom: 50px;
    }
    `} 150ms linear 1 normal forwards`,
  },
  menuListCollapsed: {
    height: '100vh',
    paddingBottom: '50px',
    animation: `${keyframes`
    0% {
      height: 100vh;
      padding-bottom: 50px;
    }
    98% {
      height: 100vh;
      padding-bottom: 50px;
    }
    99% {
      height: unset;
      padding-bottom: 0px;
    }
    100% {
      height: unset;
      padding-bottom: 0px;
    }
    `} 150ms linear 1 normal forwards`,
  },
  menuListInner: {
    width: '100%',
    padding: '0px 0px',
  },
  menuItem: {
    padding: '0px 5px',
    cursor: 'default',
  },
  menuItemClickable: {
    cursor: 'pointer',
  },
  menuItemSelected: {
    display: 'inline-block',
  },
  subMenuItemSelectedRoot: {
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.04)',
    },
  },
  subMenuItemRoot: {
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.1)',
    },
  },
  icon: {
    height: 'min-content',
    minHeight: '26px',
  },
  expandIcon: {
    width: '20px',
  },
  font: {
    [theme.breakpoints.up('xs')]: {
      fontSize: '12px !important',
    },
  },
  lvl2SubMenuItem: {
    color: '#AFA0F5',
  },
  lvl2SubMenuItemSelected: {
    color: '#7D6FBE',
  },
  inactiveIcon: {
    cursor: 'no-drop',
  },
  overflowStyle: {
    maxWidth: 110,
    color: theme.palette.framework.system.doveGray,
  },
  subItemOverflowStyle: {
    maxWidth: 150,
  },
  overflowtooltip: {
    padding: '7px 12px',
  },
  menuItemOverflowToolTip: {
    padding: '7px 12px',
    color: 'black',
    backgroundColor: 'white',
    boxShadow: '0px 3px 6px #00000029',
  },
  tooltipArrow: {
    color: '#ffffff',
    opacity: 1,
    '&::before': {
      boxShadow: '0px 3px 6px #00000029',
      border: '1px solid #E3DFDF',
    },
  },
  activeIcon: {
    cursor: 'pointer',
  },
  listWrapperExpanded: {
    width: 'auto',
    animation: `${keyframes`
    0% {
      width: auto;
    }
    100% {
      width: 181px;
    }
    `} 150ms linear 1 normal forwards`,
  },
  listWrapperCollapsed: {
    width: '181px',
    animation: `${keyframes`
    0% {
      width: 181px;
    }
    100% {
      width: auto;
    }
    `} 150ms linear 1 normal forwards`,
  },
  subItemName: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconMenuName: {
    paddingLeft: '9px',
    fontSize: '12px',
    lineHeight: '19px',
    fontFamily: 'Roboto',
    color: theme.palette.system.black,
  },
  menustyle: {
    cursor: 'pointer',
    padding: '9px 0px 8px 21px',
    fontFamily: 'Roboto',
    fontSize: '14px',
    lineHeight: '19px',
    color: theme.palette.system.black,
  },
  popperMenu: {
    padding: '10px 0px 0px 18px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    lineHeight: '16px',
    color: theme.palette.framework.system.tertiaryGrey,
  },
}));

export const SideNavStick = () => {
  useInjectReducer({ key: navigationStickSliceKey, reducer: navigationStickReducers });
  const [homeCoverage] = useDecision(ff_ui_showhomecoverage);
  const [marginTool] = useDecision(ff_order_margintool, { autoUpdate: true });
  const [tasksPage] = useDecision(ff_task_ui_taskspage, { autoUpdate: true });
  const [candidateLeadsManagement] = useDecision(ff_candidate_leads_management, { autoUpdate: true });
  const [expandSubMenu, setExpandSubMenu] = React.useState<{ [menuKey: string]: boolean }>({});

  const { classes, cx } = useStyles();
  const dispatch = useDispatch();
  const history = useNavigate();
  const { navigationMenu, selectedMenu, selectedSubMenu, navigationExpanded } = useSelector(selectNavigationStick);
  const appUser = useSelector(selectUser);
  const workDeskRef = React.useRef<HTMLDivElement>(null);
  const reportsRef = React.useRef<HTMLDivElement>(null);
  const recentHistoryRef = React.useRef<HTMLDivElement>(null);
  const settingsRef = React.useRef<HTMLDivElement>(null);
  useRecentHistoryNavigation();
  const [pricingWorkDeskDecision] = useDecision(ff_pricing_ui_pricingworkdesk);
  const brainReportURL = `${globalThis?.app?.env?.REACT_APP_REPORT_BRAIN_URL}`;
  const r108ReportURL = `${globalThis?.app?.env?.REACT_APP_REPORT_R108_URL}`;
  const setHomePage = (path, useSubMenu = false) => {
    // determine home page by user role
    const foundDefaultPage = navigationMenu[0].subMenu?.find(
      item => item.key === localStorage.getItem(DEFAULT_HOME_PAGE_LOCAL_STORAGE_KEY),
    );

    let isPricingWorkDeskDefault = false;
    if (foundDefaultPage?.key === 'pricingWorkDesk' && !pricingWorkDeskDecision?.enabled) {
      localStorage.removeItem(DEFAULT_HOME_PAGE_LOCAL_STORAGE_KEY);
      isPricingWorkDeskDefault = true;
    }
    if (
      appUser.userInfo?.multiroled &&
      foundDefaultPage &&
      Authorized(foundDefaultPage.roles || [], appUser.userInfo) &&
      path === '/' &&
      !isPricingWorkDeskDefault
    ) {
      if (useSubMenu || !selectedSubMenu) dispatch(navigationStickActions.setSelectedSubMenu(foundDefaultPage));
    } else if (path === '/') {
      // application root
      if (isGrantedAllDashboards(appUser.userInfo?.roles || []) || isRecruitment(appUser.userInfo?.roles || []))
        dispatch(
          navigationStickActions.setSelectedSubMenu(
            navigationMenu[0].subMenu?.find(item => item.key === 'recruiterWorkDesk'),
          ),
        );
      else if (isCredentialing(appUser.userInfo?.roles || []))
        dispatch(
          navigationStickActions.setSelectedSubMenu(
            navigationMenu[0].subMenu?.find(item => item.key === 'credentialingWorkDesk'),
          ),
        );
      else if (isAccountManagement(appUser.userInfo?.roles || []))
        dispatch(
          navigationStickActions.setSelectedSubMenu(
            navigationMenu[0].subMenu?.find(item => item.key === 'accountManagementWorkDesk'),
          ),
        );
    } else if (path.startsWith('/placementreminders') || path.startsWith('/expiringcredentials')) {
      dispatch(
        navigationStickActions.setSelectedSubMenu(
          navigationMenu[0].subMenu?.find(item => item.key === 'credentialingWorkDesk'),
        ),
      );
    }
  };

  // set defaults for menu on first render
  useEffect(() => {
    if (!selectedSubMenu) setHomePage(window.location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname, pricingWorkDeskDecision]);

  useEffect(() => {
    if (navigationMenu?.length > 0) {
      const homeValue = navigationMenu?.find(item => item?.key === NavigationStick.home);
      const isCoverageOptionExists = homeValue?.subMenu?.some(item => item?.key === NavigationStick.coverage);
      const defaultPage = localStorage.getItem(DEFAULT_HOME_PAGE_LOCAL_STORAGE_KEY);
      if (isCoverageOptionExists && defaultPage === HomePage.COVERAGE) setHomePage(window.location.pathname, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigationMenu]);

  useEffect(() => {
    if (homeCoverage?.enabled) {
      const NavigationOptions = [...navigationMenu];
      const homeValueIndex = NavigationOptions?.findIndex(item => item.key === 'home');
      const homeValue = NavigationOptions?.find(item => item.key === 'home');
      const subOptions = [...homeValue?.subMenu];
      const isCoverageOptionExists = subOptions?.some(item => item?.key === 'coverage');
      if (!isCoverageOptionExists) {
        const newNavigationPath: NavigationOption<NavigationSubTypes, string> = {
          key: 'coverage',
          name: 'home.coverageWorkDesk.coverageTab',
          path: '/',
          roles: [userRoles.all],
        };
        subOptions?.push(newNavigationPath);
        const updatedHomeValue = { ...homeValue, subMenu: subOptions };
        NavigationOptions[homeValueIndex] = { ...updatedHomeValue };
      }
      dispatch(navigationStickActions.setNavigationNewOptions(NavigationOptions));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeCoverage]);

  useEffect(() => {
    if (marginTool?.enabled === false) {
      dispatch(navigationStickActions.removeMenuByKey({ key: 'margin' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marginTool]);

  useEffect(() => {
    if (tasksPage?.enabled === false) {
      dispatch(navigationStickActions.removeMenuByKey({ key: 'task' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tasksPage]);

  useEffect(() => {
    if (candidateLeadsManagement?.enabled === false) {
      dispatch(navigationStickActions.removeMenuByKey({ key: 'candidateEngagement' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateLeadsManagement]);

  const navigate = item => {
    //to reset grids state
    if (!window.location.pathname.includes(item.path)) {
      dispatch(gridStateActions.reset());
    }
    /**Reset action to remove existing page breadcrumbs */
    dispatch(breadcrumbActions.reset());
    dispatch(globalSearchActions.setDrawerData({ open: false, data: undefined }));
    if (item.path) history(item.path);
    else if (['r108'].includes(item?.key)) openInNewTab(r108ReportURL);
    else if (['brain'].includes(item?.key)) openInNewTab(brainReportURL);
    else if (item.pushState) window.history.pushState(null, '', `${window.location.pathname}${item.pushState}`);
  };

  const handleCustomAction = (
    subMenuItem: INavigation | NavigationOption<NavigationSubTypes> | NavigationOption<string>,
  ) => {
    switch (subMenuItem.action.type) {
      case 'candidateDrawer':
        dispatch(globalSearchActions.setDrawerData({ open: false, data: undefined }));
        dispatch(globalActions.resetAllRecentHistoryDrawers());
        dispatch(globalActions.setDetailsPageDrawer({ open: false }));
        dispatch(globalActions.setSmsIconDrawer({ open: false }));
        dispatch(globalActions.setCandidateDrawerData(subMenuItem.action.data));
        break;
      case 'placementDrawer':
        history(`/placement/${subMenuItem.action.data?.placementId}`,
          {
            state: { navigateBack: true },
        });
        break;
      case 'orderDrawer':
        dispatch(globalSearchActions.setDrawerData({ open: false, data: undefined }));
        dispatch(globalActions.resetAllRecentHistoryDrawers());
        dispatch(globalActions.setOrderDrawerData(subMenuItem.action.data));
        break;
      case 'facilityDrawer':
        dispatch(globalSearchActions.setDrawerData({ open: false, data: undefined }));
        dispatch(globalActions.resetAllRecentHistoryDrawers());
        dispatch(globalActions.setFacilityDrawerData(subMenuItem.action.data));
        break;
      default:
        break;
    }
  };

  const fetchRefKey = option => {
    const refData =
      option?.key === NavigationStick?.home
        ? workDeskRef
        : option?.key === NavigationStick?.report
        ? reportsRef
        : option?.key === NavigationStick.recentHistory
        ? recentHistoryRef
        : option?.key === NavigationStick.settings
        ? settingsRef
        : null;
    return refData;
  };

  const menuItemClicked = (menuItem: INavigation) => {
    if (!menuItem.disabled) {
      const a = { ...expandSubMenu, [menuItem.key]: true };
      setExpandSubMenu(a);
      dispatch(globalSearchActions.setShowPreferenceFilterDropdown(true));
      if (!['report', 'recentHistory', 'settings'].includes(menuItem?.key))
        dispatch(navigationStickActions.setSelectedSubMenu(undefined));
      if (selectedMenu?.key !== menuItem.key && !['report', 'recentHistory', 'settings'].includes(menuItem?.key))
        dispatch(navigationStickActions.setSelectedMenu(menuItem));
      if (menuItem.key === 'home') {
        dispatch(globalSearchActions.setSearchOptions(initialSearchAttributes));
        setHomePage(menuItem.path, true);
        trackEvent({
          type: 'navigation',
          name: 'Home button clicked',
        });
      }
      navigate(menuItem);
    }
  };

  const subMenuItemClicked = (
    event,
    menuItem: INavigation,
    subMenuItem: NavigationOption<NavigationSubTypes> | NavigationOption<string>,
  ) => {
    if (
      !subMenuItem.disabled &&
      (!subMenuItem.enableOnlyForRoute ||
        (subMenuItem.enableOnlyForRoute && window.location.pathname.startsWith(subMenuItem.enableOnlyForRoute)))
    ) {
      if (subMenuItem.action) {
        handleCustomAction(subMenuItem);
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (selectedMenu?.key !== menuItem.key) dispatch(navigationStickActions.setSelectedMenu(menuItem));
      dispatch(navigationStickActions.setSelectedSubMenu(subMenuItem));
      if (menuItem.key === 'home') {
        dispatch(globalSearchActions.setSearchOptions(initialSearchAttributes));
        trackEvent({
          type: 'navigation',
          name: 'Home button clicked',
        });
      }
      navigate(subMenuItem);
    }
    event.preventDefault();
    event.stopPropagation();
  };

  const toggleMenu = () => {
    const open = !navigationExpanded;
    if (open) {
      dispatch(navigationStickActions.expandNavigation(true));
      setExpandSubMenu({ ...expandSubMenu, [NavigationStick.report]: true });
    } else {
      closeMenu();
    }
  };

  const closeMenu = () => {
    if (navigationExpanded) {
      setExpandSubMenu({});
      dispatch(navigationStickActions.expandNavigation(false));
    }
  };

  const expandCollapseSubMenu = (
    menuItem: INavigation | NavigationOption<NavigationSubTypes, string> | NavigationOption<string>,
    parentMenuItem?: INavigation | NavigationOption<NavigationSubTypes, string> | NavigationOption<string>,
  ) => {
    setExpandSubMenu({ ...expandSubMenu, [menuItem.key]: !expandSubMenu[menuItem.key] });
    if (parentMenuItem?.singleSubMenuExpandable && parentMenuItem?.subMenu) {
      // close all other sub menus in the parent sub menu list
      parentMenuItem.subMenu?.forEach(item => {
        if (item.key !== menuItem.key) {
          setExpandSubMenu(prev => ({
            ...prev,
            [item.key]: false,
          }));
        }
      });
    }
  };

  return (
    <>
      <Paper
        square
        classes={{ root: `${classes.root} ${navigationExpanded ? classes.drawer : classes.drawerCollapse}` }}
      >
        <div className={classes.collapseIcon}>
          <IconButton
            color="primary"
            disableFocusRipple
            disableRipple
            disableTouchRipple
            onClick={toggleMenu}
            size="small"
          >
            {navigationExpanded ? (
              <ArrowBackIcon className={classes.headerIcon} />
            ) : (
              <MenuIcon className={classes.headerIcon} />
            )}
          </IconButton>
        </div>
        <Divider />

        <div
          style={{
            position: 'relative',
            height: '100vh',
            overflow: 'hidden',
          }}
          className={cx({
            [classes.listWrapperExpanded]: navigationExpanded,
            [classes.listWrapperCollapsed]: !navigationExpanded,
          })}
        >
          <List
            id="global-nav-list"
            disablePadding
            className={cx(classes.menuList, {
              [classes.menuListExpanded]: navigationExpanded,
              [classes.menuListCollapsed]: !navigationExpanded,
            })}
            sx={{ overflowY: 'auto' }}
          >
            {navigationMenu.map((menuItem, index) => (
              <PrivateComponent roles={menuItem.roles} key={index}>
                <NavMenuItem
                  menuItem={menuItem}
                  selectedMenu={selectedMenu}
                  selectedSubMenu={selectedSubMenu}
                  index={index}
                  navigationExpanded={navigationExpanded}
                  expandSubMenu={expandSubMenu}
                  menuItemClicked={menuItemClicked}
                  expandCollapseSubMenu={expandCollapseSubMenu}
                  subMenuItemClicked={subMenuItemClicked}
                  fetchRefKey={fetchRefKey}
                />
              </PrivateComponent>
            ))}
          </List>
        </div>
      </Paper>
    </>
  );
};

const NavMenuItem = ({ ...props }) => {
  const { menuItem, selectedMenu, selectedSubMenu, index, navigationExpanded, expandSubMenu, fetchRefKey } = props;
  const { classes, cx } = useStyles();
  const { t } = useTranslation();
  const [selectedFeedData, setSelectedFeedData] = useState<INavigationPopperState>({
    id: null,
    currentPopper: '',
    openPopper: false,
    currentRef: null,
    menuItem: null,
  });

  const { isMenuItemSelected, isSubMenuSelected } = React.useMemo(
    () => ({
      isMenuItemSelected: selectedMenu?.key === menuItem.key,
      isSubMenuSelected:
        selectedSubMenu && menuItem.subMenu?.some(x => (x.subMenu ?? []).map(i => i.key).includes(selectedSubMenu.key)),
    }),
    [selectedMenu, selectedSubMenu, menuItem],
  );
  const handleClose = () => {
    setSelectedFeedData({ openPopper: false, currentRef: null });
  };

  const handleHover = (event, option) => {
    if (option?.subMenu && !navigationExpanded) {
      setSelectedFeedData({
        id: option.key,
        currentPopper: option.key,
        openPopper: true,
        currentRef: fetchRefKey(option),
        menuItem: option,
      });
    }
  };

  return (
    <React.Fragment>
      <div
        key={menuItem?.key}
        id={menuItem?.key}
        ref={fetchRefKey(menuItem)}
        onMouseEnter={e => {
          handleHover(e, menuItem);
        }}
        onMouseLeave={handleClose}
      >
        <Tooltip
          classes={{
            tooltip: classes.menuItemOverflowToolTip,
            arrow: classes.tooltipArrow,
          }}
          arrow
          title={!navigationExpanded && !menuItem?.subMenu ? t(`${menuItem?.name}`) : ''}
          placement="right"
        >
          <ListItem
            classes={{
              root: cx(classes.listItem, {
                [classes.borderSelection]: isMenuItemSelected,
              }),
              gutters: classes.listItemGutters,
            }}
            key={menuItem.tag}
            className={cx({
              [classes.option]: !isMenuItemSelected && !isSubMenuSelected,
              [classes.optionSelected]: isMenuItemSelected || isSubMenuSelected,
            })}
          >
            <ListItemIcon
              classes={{
                root: `${classes.listIcon}`,
              }}
            >
              <Grid container wrap="nowrap" style={{ marginLeft: '0px' }}>
                <Grid
                  item
                  className={cx(classes.icon, {
                    [classes.invertItemColor]: !isMenuItemSelected && !isSubMenuSelected,
                    [classes.inactiveIcon]: menuItem.disabled,
                    [classes.activeIcon]: !menuItem.disabled && menuItem.clickable !== false,
                  })}
                  onClick={() => {
                    if (menuItem.clickable !== false) {
                      props.menuItemClicked(menuItem);
                      handleClose();
                    }
                  }}
                >
                  {getStickIcons(menuItem.icon)}
                </Grid>
                <Grid item>
                  {
                    <div
                      id={`navigation-expandable-${index}`}
                      className={cx(classes.menuInner, classes.menuInnerCollapsed, classes.menuInnerExpanded, {
                        [classes.menuItemSelected]: isMenuItemSelected,
                        'navigation-expanded': navigationExpanded === true,
                        'navigation-collapsed': navigationExpanded === false,
                      })}
                    >
                      <List
                        disablePadding
                        className={classes.menuListInner}
                        style={{
                          color: isMenuItemSelected || isSubMenuSelected ? colors.amnPurple : 'white',
                        }}
                      >
                        <ListItem
                          disabled={menuItem.disabled}
                          disableGutters
                          className={cx(classes.menuItem, {
                            [classes.menuItemClickable]: menuItem.clickable !== false,
                          })}
                        >
                          <ListItemText
                            primaryTypographyProps={{ className: classes.font }}
                            onClick={() => {
                              if (menuItem.clickable !== false) props.menuItemClicked(menuItem);
                            }}
                          >
                            {t(`navStick.${menuItem.tag}`)}
                          </ListItemText>
                          {menuItem.subMenu && (
                            <Box
                              onClick={() => {
                                props.expandCollapseSubMenu(menuItem);
                              }}
                            >
                              {expandSubMenu[menuItem.key] ? (
                                <ExpandLess
                                  className={cx(classes.expandIcon, {
                                    [classes.menuItemClickable]: !menuItem.disabled,
                                  })}
                                />
                              ) : (
                                <ExpandMore
                                  className={cx(classes.expandIcon, {
                                    [classes.menuItemClickable]: !menuItem.disabled,
                                  })}
                                />
                              )}
                            </Box>
                          )}
                        </ListItem>
                        {menuItem.subMenu && (
                          <SubMenu
                            menuItem={menuItem}
                            expandSubMenu={expandSubMenu}
                            onExpand={props.expandCollapseSubMenu}
                            selectedMenu={selectedMenu}
                            selectedSubMenu={selectedSubMenu}
                            navigationExpanded={navigationExpanded}
                            subMenuItemClicked={props.subMenuItemClicked}
                            level={0}
                          />
                        )}
                      </List>
                    </div>
                  }
                </Grid>
              </Grid>
            </ListItemIcon>
          </ListItem>
        </Tooltip>
      </div>
      {selectedFeedData.openPopper && (
        <Popper
          open={selectedFeedData.openPopper}
          anchorEl={selectedFeedData.currentRef?.current}
          placement="right-start"
          style={{ zIndex: '1300', backgroundColor: 'white', minWidth: '184px', boxShadow: '0px 2px 8px ##0000004D' }}
          onMouseEnter={e => {
            handleHover(e, menuItem);
          }}
          onMouseLeave={handleClose}
        >
          <Paper>
            <Grid style={{ display: 'flex', flexDirection: 'column' }}>
              <Grid item className={classes.popperMenu}>
                {menuItem?.key === NavigationStick.home ? t('home.amWorkDesk.workDeskTitle') : t(`${menuItem?.name}`)}
              </Grid>
              <Grid item>
                <Grid>
                  <SubItemPopper
                    menuItem={menuItem}
                    expandSubMenu={expandSubMenu}
                    selectedMenu={selectedMenu}
                    selectedSubMenu={selectedSubMenu}
                    subMenuItemClicked={(e, menuItemDetails, subMenuItemDetails) => {
                      props.subMenuItemClicked(e, menuItemDetails, subMenuItemDetails);
                      handleClose();
                    }}
                    onExpand={props.expandCollapseSubMenu}
                    level={0}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Popper>
      )}
    </React.Fragment>
  );
};

interface ISubMenu {
  menuItem: INavigation | NavigationOption<NavigationSubTypes, string>;
  expandSubMenu: { [menuKey: string]: boolean };
  onExpand?: (
    menuItem: INavigation | NavigationOption<NavigationSubTypes, string> | NavigationOption<string>,
    parentMenuItem?: INavigation | NavigationOption<NavigationSubTypes, string> | NavigationOption<string>,
  ) => void;
  selectedMenu: INavigation;
  selectedSubMenu: NavigationOption<NavigationSubTypes, {}> | NavigationOption<string, {}>;
  subMenuItemClicked: (event, menuItem, subMenuItem) => void;
  level: number;
  navigationExpanded?: boolean;
}

const SubMenu = (props: ISubMenu) => {
  const {
    menuItem,
    expandSubMenu,
    onExpand,
    selectedMenu,
    selectedSubMenu,
    subMenuItemClicked,
    level,
    navigationExpanded,
  } = props;
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  // TODO: @Rijash - Figure out an alternative for Optimizely flags, 18th July 2023

  const subMenuItems = useFetchSubMenuList(menuItem);

  return (
    <Collapse in={navigationExpanded ? expandSubMenu[menuItem.key] : false} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        {subMenuItems.map((subMenuItem: any, subsubIndex: number) => (
          <PrivateComponent roles={subMenuItem.roles} key={subsubIndex}>
            <ListItem
              disabled={
                subMenuItem.disabled ||
                (!!subMenuItem.enableOnlyForRoute &&
                  !window.location.pathname.startsWith(subMenuItem.enableOnlyForRoute))
              }
              disableGutters
              className={cx(classes.menuItem, {
                [classes.menuItemClickable]: subMenuItem.clickable !== false || subMenuItem.action,
                [classes.subMenuItemSelectedRoot]: menuItem.key === selectedMenu?.key,
                [classes.subMenuItemRoot]: menuItem.key !== selectedMenu?.key,
                [classes.lvl2SubMenuItem]: level >= 1,
                [classes.lvl2SubMenuItemSelected]: level >= 1 && !!selectedSubMenu,
              })}
              onClick={event => {
                if (subMenuItem.clickable !== false || !isNullOrUndefined(subMenuItem.action))
                  subMenuItemClicked(event, menuItem, subMenuItem);
              }}
              selected={subMenuItem.key === selectedSubMenu?.key}
            >
              <ListItemText
                primaryTypographyProps={{ className: classes.font }}
                title={subMenuItem.title}
                onClick={() => {
                  if (subMenuItem.subMenu) {
                    onExpand?.(subMenuItem, menuItem);
                  }
                }}
              >
                {subMenuItem.removeTextOverflow ? (
                  <OverflowTooltip
                    contentClass={classes.subItemOverflowStyle}
                    value={t(`${subMenuItem.name}`)}
                    placement="right"
                    classes={{ tooltip: classes.overflowtooltip }}
                  />
                ) : (
                  t(`${subMenuItem.name}`)
                )}
              </ListItemText>
              {subMenuItem.subMenu && (
                <Box
                  onClick={() => {
                    onExpand?.(subMenuItem, menuItem);
                  }}
                  className={classes.menuItemClickable}
                >
                  {expandSubMenu[subMenuItem.key] ? (
                    <ExpandLess
                      className={cx(classes.expandIcon, { [classes.menuItemClickable]: !subMenuItem.disabled })}
                    />
                  ) : (
                    <ExpandMore
                      className={cx(classes.expandIcon, { [classes.menuItemClickable]: !subMenuItem.disabled })}
                    />
                  )}
                </Box>
              )}
            </ListItem>
            {subMenuItem.subMenu && (
              <SubMenu
                menuItem={subMenuItem}
                expandSubMenu={expandSubMenu}
                onExpand={onExpand}
                selectedMenu={selectedMenu}
                selectedSubMenu={selectedSubMenu}
                subMenuItemClicked={subMenuItemClicked}
                navigationExpanded={navigationExpanded}
                level={level + 1}
              />
            )}
          </PrivateComponent>
        ))}
      </List>
    </Collapse>
  );
};

const getMenuItemName = (subMenuItem, t, level, classes) => {
  if (level === 0) {
    switch (subMenuItem.key) {
      case 'recentCandidate':
        return (
          <span className={classes.subItemName}>
            <img
              src={CandidateIcon}
              alt="CandidateIcon"
              height={15}
              width={15}
              style={{ filter: 'grayscale(100%) brightness(1.8)' }}
            />
            <span className={classes.iconMenuName}>{t(`${subMenuItem.name}`)}</span>
          </span>
        );
      case 'recentOrder':
        return (
          <span className={classes.subItemName}>
            <img
              src={OrdersIcon}
              alt="OrdersIcon"
              height={15}
              width={15}
              style={{ filter: 'grayscale(100%)  brightness(1.8)' }}
            />
            <span className={classes.iconMenuName}>{t(`${subMenuItem.name}`)}</span>
          </span>
        );
      case 'recentFacility':
        return (
          <span className={classes.subItemName}>
            <img
              src={FacilityIcon}
              alt="FacilityIcon"
              height={15}
              width={15}
              style={{ filter: 'grayscale(100%)  brightness(1.8)' }}
            />
            <span className={classes.iconMenuName}>{t(`${subMenuItem.name}`)}</span>
          </span>
        );
      case 'recentPlacement':
        return (
          <span className={classes.subItemName}>
            <img
              src={PlacementIcon}
              alt="PlacementIcon"
              height={15}
              width={15}
              style={{ filter: 'grayscale(100%)  brightness(1.8)' }}
            />
            <span className={classes.iconMenuName}>{t(`${subMenuItem.name}`)}</span>
          </span>
        );
      default:
        return t(`${subMenuItem.name}`);
    }
  } else {
    return t(`${subMenuItem.name}`);
  }
};

const SubItemPopper = ({ ...props }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { menuItem, selectedMenu, selectedSubMenu, subMenuItemClicked, onExpand, expandSubMenu, level } = props;
  const subMenuItems = useFetchSubMenuList(menuItem);

  return (
    <Collapse in={level > 0 ? expandSubMenu[menuItem.key] : true} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        {subMenuItems.map((subMenuItem: any, subIndex: number) => (
          <PrivateComponent roles={subMenuItem.roles} key={subIndex}>
            <ListItem
              disabled={
                subMenuItem.disabled ||
                (!!subMenuItem.enableOnlyForRoute &&
                  !window.location.pathname.startsWith(subMenuItem.enableOnlyForRoute))
              }
              onMouseEnter={() => {
                level === 0 && setHoveredIndex(subIndex);
              }}
              onMouseLeave={() => setHoveredIndex(null)}
              disableGutters
              style={{
                height: '36px',
                backgroundColor:
                  hoveredIndex === subIndex
                    ? theme.palette.framework.system.smoke
                    : level === 0 && subMenuItem?.key === selectedSubMenu?.key
                    ? theme.palette.framework.system.paleSkyBlue
                    : 'transparent',
              }}
              className={cx(classes.menuItem, {
                [classes.menuItemClickable]: subMenuItem.clickable !== false || subMenuItem.action,
                [classes.subMenuItemSelectedRoot]: menuItem.key === selectedMenu?.key,
                [classes.subMenuItemRoot]: menuItem.key !== selectedMenu?.key,
                [classes.lvl2SubMenuItem]: level >= 1,
                [classes.lvl2SubMenuItemSelected]: level >= 1 && !!selectedSubMenu,
              })}
              onClick={event => {
                if (subMenuItem.clickable !== false || !isNullOrUndefined(subMenuItem.action))
                  subMenuItemClicked(event, menuItem, subMenuItem);
              }}
              selected={subMenuItem.key === selectedSubMenu?.key}
            >
              <ListItemText
                primaryTypographyProps={{ className: classes.font }}
                title={subMenuItem.title}
                className={classes.menustyle}
                onClick={() => {
                  if (subMenuItem.subMenu) {
                    onExpand?.(subMenuItem, menuItem);
                  }
                }}
              >
                {subMenuItem.removeTextOverflow ? (
                  <OverflowTooltip
                    contentClass={classes.overflowStyle}
                    value={t(`${subMenuItem.name}`)}
                    placement="right"
                    classes={{ tooltip: classes.overflowtooltip }}
                  />
                ) : (
                  getMenuItemName(subMenuItem, t, level, classes)
                )}
              </ListItemText>
              {subMenuItem.subMenu && (
                <Box
                  onClick={() => {
                    onExpand?.(subMenuItem, menuItem);
                  }}
                  className={classes.menuItemClickable}
                >
                  {expandSubMenu[subMenuItem.key] ? (
                    <ExpandLess
                      className={cx(classes.expandIcon, { [classes.menuItemClickable]: !subMenuItem.disabled })}
                    />
                  ) : (
                    <ExpandMore
                      className={cx(classes.expandIcon, { [classes.menuItemClickable]: !subMenuItem.disabled })}
                    />
                  )}
                </Box>
              )}
            </ListItem>
            {subMenuItem.subMenu && (
              <SubItemPopper
                menuItem={subMenuItem}
                expandSubMenu={expandSubMenu}
                onExpand={onExpand}
                selectedMenu={selectedMenu}
                selectedSubMenu={selectedSubMenu}
                subMenuItemClicked={subMenuItemClicked}
                level={level + 1}
              />
            )}
          </PrivateComponent>
        ))}
      </List>
    </Collapse>
  );
};
